import { newsActions } from "../../actionTypes";
import { getNews } from "../../../api/libs/news";

export const fetchNews = id => {
	return async dispatch => {
		dispatch({
			type: newsActions.FETCH_NEWS,
		});
		getNews(id)
			.then(res => {
				dispatch({
					type: newsActions.FETCH_NEWS_FULFILLED,
					payload: res.data,
				});
			})
			.catch(err => {
				dispatch({
					type: newsActions.FETCH_NEWS_REJECTED,
					payload: err.response.data,
				});
			});
	};
};
